import React from 'react';

const TableHeader = () => {
  return (
    <div className="flex w-full">
      <div className="w-[20%] min-w-[200px] px-2 py-3 text-sm sm:text-base md:text-lg lg:text-xl font-medium text-white whitespace-nowrap bg-cyan-800 rounded-tl-xl">
        Scope
      </div>
      <div className="w-[10%] min-w-[100px] px-2 py-3 text-sm sm:text-base md:text-lg lg:text-xl font-medium text-white bg-indigo-600">
        % of Hours Used
      </div>
      <div className="w-[10%] min-w-[100px] px-2 py-3 text-sm sm:text-base md:text-lg lg:text-xl font-medium text-white bg-indigo-600">
        % of Units Placed
      </div>
      <div className="w-[7.5%] min-w-[80px] px-2 py-3 text-sm sm:text-base md:text-lg lg:text-xl font-medium text-white bg-amber-500">
        Crew Size
      </div>
      <div className="w-[7.5%] min-w-[80px] px-2 py-3 text-sm sm:text-base md:text-lg lg:text-xl font-medium text-white bg-amber-500">
        Est. Crew Days
      </div>
      <div className="w-[10%] min-w-[110px] px-2 py-3 text-sm sm:text-base md:text-lg lg:text-xl font-medium text-white bg-cyan-600">
        Production Per Day
      </div>
      <div className="w-[10%] min-w-[110px] px-2 py-3 text-sm sm:text-base md:text-lg lg:text-xl font-medium text-white bg-cyan-600">
        Crew Days Used
      </div>
      <div className="w-[12.5%] min-w-[150px] px-2 py-3 text-sm sm:text-base md:text-lg lg:text-xl font-medium text-white bg-stone-500">
        Rental Equipment
      </div>
      <div className="w-[12.5%] min-w-[150px] px-2 py-3 text-sm sm:text-base md:text-lg lg:text-xl font-medium text-white rounded-tr-xl bg-stone-500">
        Rental Equipment Days
      </div>
    </div>
  );
};

export default TableHeader;